module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/global-data/global-data-form/global-data-form.component.css
// module id = ./src/app/technical/global-data/global-data-form/global-data-form.component.css
// module chunks = main